import React from 'react';

export function dp(value, places) {
    if (typeof value === 'number') {
        return value.toFixed(places === undefined ? 2 : places);
    }
    return value;
}

export function howoutClass(howout) {
    return `cc-howout cc-howout-${howout
        .toLowerCase()
        .replace(' ', '_')
        .replace('&', 'a')}`;
}

export function totalScore(runs, wickets) {
    if (wickets === 10) {
        return `${runs} all out`;
    }
    return `${runs}-${wickets}`;
}

export function runs(runs, howout) {
    if (howout === 'DNB') {
        return '';
    }
    if (howout !== 'NOT OUT' && (runs === 0 || runs === '0')) {
        return <img src="/icons/duck.png" height="15" />;
    }
    return runs;
}

export function seasonString(season) {
    if (season === 'all') {
        return 'All Seasons';
    }
    return `${season} Season`;
}

export function isTouchDevice() {
    return (
        'ontouchstart' in window || navigator.maxTouchPoints // works on most browsers
    ); // works on IE10/11 and Surface
}

export function dateRows(fixtures, stripeDay, func) {
    let lastDate;
    return fixtures.map(fixture => {
        const date = new Date(fixture.link_date);
        let rowClassName = '';
        if (stripeDay >= 0 && date.getDay() !== stripeDay) {
            rowClassName = 'cc-row-striped';
        }
        let longDate = '';
        let shortestDate = '';
        if (!lastDate || lastDate.getTime() !== date.getTime()) {
            longDate = fixture.long_date;
            shortestDate = fixture.shortest_date;
            if (lastDate) {
                rowClassName += ' cc-row-border';
            }
        }
        lastDate = date;
        return func(fixture, longDate, shortestDate, rowClassName);
    });
}



// WEBPACK FOOTER //
// ./src/components/util.js